export function initShowroomColorizer() {
  document.querySelectorAll('[data-colorizer]').forEach(root => {
    const stage = root.querySelector('[data-colorizer-stage]');
    const images = [...stage.querySelectorAll('img[data-color]')];
    const swatches = [...root.querySelectorAll('[data-colorizer-swatch]')];
    const dots = [...root.querySelectorAll('[data-colorizer-dots] > span')];
    const name = root.querySelector('[data-colorizer-name]');
    const angleCount = Math.max(1, dots.length);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let color = 0;
    let angle = 0;
    let request = 0;

    const imageFor = (c, a) => images.find(img => Number(img.dataset.color) === c && Number(img.dataset.angle) === a)
      || images.find(img => Number(img.dataset.color) === c);

    const load = img => {
      if (img && !img.getAttribute('src') && img.dataset.src) {
        img.src = img.dataset.src;
      }

      return img;
    };

    const ready = img => (img.decode ? img.decode().catch(() => {}) : Promise.resolve());

    const show = (next, keepUnder) => {
      const current = stage.querySelector('img.is-active');

      if (!next || next === current) {
        return;
      }

      const ticket = ++request;

      ready(next).then(() => {
        if (ticket !== request) {
          return;
        }

        stage.querySelectorAll('img.is-under').forEach(img => img.classList.remove('is-under'));

        if (current) {
          current.classList.remove('is-active');
          current.setAttribute('aria-hidden', 'true');

          if (keepUnder && !reduceMotion) {
            current.classList.add('is-under');
            setTimeout(() => current.classList.remove('is-under'), 450);
          }
        }

        next.classList.add('is-active');
        next.removeAttribute('aria-hidden');
      });
    };

    const setAngle = a => {
      angle = (a + angleCount) % angleCount;
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === angle));
      show(load(imageFor(color, angle)), false);
    };

    const setColor = c => {
      if (c === color) {
        return;
      }

      color = c;
      swatches.forEach((swatch, i) => {
        swatch.setAttribute('aria-pressed', i === color ? 'true' : 'false');
        swatch.querySelector('.round-color')?.classList.toggle('active', i === color);
      });

      if (name) {
        name.textContent = swatches[color].dataset.name;
        name.classList.remove('lbx-name-in');
        void name.offsetWidth;
        name.classList.add('lbx-name-in');
      }

      show(load(imageFor(color, angle)), true);
      images.filter(img => Number(img.dataset.color) === color).forEach(load);
    };

    swatches.forEach((swatch, i) => {
      swatch.addEventListener('click', () => setColor(i));
      ['pointerenter', 'focus'].forEach(type => swatch.addEventListener(type, () => load(imageFor(i, angle)), { once: true }));
    });

    root.querySelectorAll('[data-colorizer-prev]').forEach(btn => btn.addEventListener('click', () => setAngle(angle - 1)));
    root.querySelectorAll('[data-colorizer-next]').forEach(btn => btn.addEventListener('click', () => setAngle(angle + 1)));

    let startX = null;
    stage.addEventListener('pointerdown', event => {
      startX = event.clientX;
    });
    stage.addEventListener('pointerup', event => {
      if (startX === null || angleCount < 2) {
        return;
      }

      const distance = event.clientX - startX;
      startX = null;

      if (Math.abs(distance) > 40) {
        setAngle(angle + (distance < 0 ? 1 : -1));
      }
    });
    stage.addEventListener('pointercancel', () => {
      startX = null;
    });
  });
}
